(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('staticBreadcrumb', function($rootScope, arrayUtil, $location, currentDestination, urlUtils, pageStrand, $timeout) {
    return {
        restrict: 'E',
        templateUrl: 'partials/home/directivetemplate?type=StaticBreadcrumb',
        replace: true,
        link(scope, element) {
            currentDestination.getCurrentDestination().then(function(dest) {
                if (dest == null || dest.BreadcrumbTrail == null) {
                    return;
                }
                scope.class = function(index) {
                    return index === dest.BreadcrumbTrail.length - 1 ? 'active' : '';
                };

                scope.category = dest.PageStrand;
                scope.categoryRoute = pageStrand.toRoute(dest.PageStrand);
                scope.show = dest.BreadcrumbTrail != null;
                scope.crumbs = arrayUtil.numberArray(0, dest.BreadcrumbTrail.length - 1);

                scope.text = function(index) {
                    return dest.BreadcrumbTrail[index].Title;
                };

                scope.getUrl = function(index, full) {
                    const d = dest.BreadcrumbTrail[index];
                    if (full) {
                        return $location.absUrl();
                    }
                    return urlUtils.stripLeadingSlash(d.PagePath);
                };

                scope.click = function(index, event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (index >= dest.BreadcrumbTrail.length - 1) {
                        return; //we would just end up where we already are in that case.
                    }

                    $location.url(scope.getUrl(index));
                };

                $timeout(() => {
                    const wrapperClass = 'sc-c-breadcrumb-scroller';
                    const wrapper = element.hasClass(wrapperClass) ? element : element.find(`.${wrapperClass}`);
                    const activeCrumb = element.find('.is-active');
                    const wrapperOffsetLeft = _.get(wrapper, '[0].offsetLeft');
                    const crumbsOffsetLeft = _.get(activeCrumb, '[0].offsetLeft');
                    const offsetPosition = crumbsOffsetLeft - wrapperOffsetLeft;

                    if (crumbsOffsetLeft && offsetPosition) {
                        wrapper[0].scrollLeft = offsetPosition;
                    }
                }, 1000);
            });
        }
    };
});
})();
